import {useEffect, useState} from 'react';
import {DateTime} from 'luxon';
import {useAppDispatch, useAppSelector} from './redux-hooks/hooks';
import {LavoratoreFilterSelection, useGetLavoratoriQuery,} from '@commons/features/lavoratore/lavoratore.api';
import {useGetAziendaQuery} from '@commons/features/azienda/api';
import {selectToken, setupContratto} from '@commons/core.slice';
import {LavoratoreRecord} from '@commons/mapping/LavoratoreRecord';
import {TokenRecord} from '@commons/mapping/TokenRecord';
import {useLavoratore} from "@commons/hooks/useLavoratore";

interface SelectListData {
    key: string,
    value: string,
}

const lavoratoreToOption = (contratto: LavoratoreRecord): SelectListData => {
    return {
        key: contratto.id.toString(),
        value: `#[${contratto.id}] - ${DateTime.fromISO(contratto.dataAssunzione!).toFormat('dd/LL/yyyy')} - ${
            contratto.dataCessazione
                ? DateTime.fromISO(contratto.dataCessazione!).toFormat('dd/LL/yyyy')
                : 'Attuale'
        } `,
    };
};

export const useContractFilter = () => {
    const {token, idAzienda}: TokenRecord = useAppSelector(selectToken);
    const {data: aziendaCorrente} = useGetAziendaQuery({idAzienda}, {skip: !token});
    const {contratto} = useLavoratore();
    const docsAndBadges={};

    const [options, setOptions] = useState<SelectListData[]>([]);
    const [filter, setFilter] = useState<string>('');
    const [defaultOption, setDefaultOption] = useState<SelectListData | undefined>();

    const dispatch = useAppDispatch();

    const filterOptions = {
        idAzienda: aziendaCorrente?.idAzienda,
        idAziendaMaster: aziendaCorrente?.idAziendaMaster,
        tipo: 'flat',
        iniziale: '*',
        tutti: 'all',
        inForzaSection: undefined,
        hiredSection: undefined,
        firedSection: undefined,
        inForza: undefined,
        hired: undefined,
        fired: undefined,
        hiredDataDa: null,
        hiredDataA: null,
        firedDataDa: null,
        firedDataA: null,
        forceDataDa: null,
        forceDataA: null,
        qualifiche: undefined,
        start: 0,
        length: 0,
        mode: 'DataTables',
        view: 'Grid',
    } as Partial<LavoratoreFilterSelection>;

    const {data: contratti} = useGetLavoratoriQuery(filterOptions, {
        skip: !filterOptions.idAziendaMaster || !filterOptions.idAzienda,
    });

    useEffect(() => {
        if (filter && contratti) {
            const contratto = contratti.data.filter((contratto) => contratto.id === Number(filter))!;
            if (contratto.length) {
                dispatch(setupContratto(contratto[0]));
            }
        }
    }, [filter, contratti, dispatch]);

    useEffect(() => {
        const options = [];

        if (contratti?.data) {
            // Popolo options e seleziono ultimo contratto valido
            for (const contratto of contratti.data) {
                const pair = lavoratoreToOption(contratto);
                options.push(pair);
                //if (!contratto.dataCessazione) {
                if (!LavoratoreRecord.isFired(contratto)) {
                    setDefaultOption(pair);
                }
            }
            if (contratto) {
                console.log("useContractFilter=>Seleziono CONTRATTO CORRENTE!")
                setDefaultOption(lavoratoreToOption(contratto));
            }
            setOptions(options);
        }
    }, [contratti, contratto]);

    return {aziendaCorrente, options, defaultOption, setFilter, docsAndBadges};
};